export const STRIPE = 'stripe';
export const BAMBORA = 'bambora';
export const PAYSAFE = 'paysafe';
